import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import Badge from "@mui/material/Badge";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import {
  Box as MuiBox,
  Card,
  CardContent,
  Grid,
  Chip,
  Button as MuiButton,
  List,
  ListItem,
  ListItemText,
  Divider,
  Paper,
  Container,
  Breadcrumbs,
  Link as MuiLink,
  Avatar,
  Stack,
  useTheme,
  IconButton,
  Tooltip,
  Fade,
  Skeleton,
  Badge as MuiBadge
} from "@mui/material";
import {
  DirectionsCar,
  Person,
  Description,
  Assignment,
  Security,
  Add as AddIcon,
  Remove as RemoveIcon,
  NavigateNext,
  ChevronRight,
  Badge as BadgeIcon,
  Palette,
  CalendarToday,
  Visibility,
  Download,
  Edit,
  Share,
  Verified,
  Speed,
  LocalGasStation,
  Phone,
  Email,
  LocationOn,
  Star,
  AccountBalance,
  AccountBalanceWallet,
  DirectionsBus,
  PermIdentity
} from "@mui/icons-material";

import Spinner from "../Spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Table from "../Theme/Table";
import { useContext } from "react";
import { RoleContext } from "../RoleContext";
import { Attachment, DirectionsCar as DirectionsCarOld, PermIdentity as PermIdentityOld } from "@mui/icons-material";
import {
  fetchDocument,
  fetchDriverImage,
  fetchVehicleImages,
} from "../fetchDocs";
import Transactions from "../Corporate/Transactions";
import { Card as CardOld, CardContent as CardContentOld, Grid as GridOld } from "@mui/material";
import { Checkbox, Dropdown, Menu, Modal, Space } from "antd";
import { handleExportTripDetail } from "../exportTripDetail";
import { Button } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import Withdrawals from "../Corporate/Withdrawals";
import Driver from "../reports/Driver";
import DriverTrips, { exportExcelDriverTrips } from "../reports/DriverTrips";
import { ATTACHMENT_TYPES, MEANS_OF_TRANSPORT_TYPES } from "../enum";
import "./viewDriver.css"
const edit = "driver";
const detail = "viewDriver";
const TabPanel = (props) => {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
};

const ViewDriver = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const roleData = useContext(RoleContext);
  var role = JSON.parse(roleData);
  const params = useParams();
  const id = params.id;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gender, setGender] = useState("");

  const [address, setAddress] = useState("");
  const [balance, setBalance] = useState("");
  const [pocket, setPocket] = useState("");
  const [driverImage, setDriverImage] = useState(null);
  const [rating, setRating] = useState();
  const [driverScince, setDriverSince] = useState();
  const [documents, setDocuments] = useState();
  const [vehicle, setVehicle] = useState({});
  const [vehicleImage, setVehicleImage] = useState();
  const [meansOfTransport, setMeansOfTransport] = useState("");

  let [loading, setLoading] = useState(true);
  let [tripsLoading, setTripsLoading] = useState(true);
  let [reportsLoading, setReportsLoading] = useState(true);
  let [driversLoading, setDriversLoading] = useState(true);
  let [vehiclesLoading, setVehiclesLoading] = useState(true);
  const [trips, setTrips] = useState([]);
  const [earnings, setEarnings] = useState([]);
  const history = useNavigate();
  const [showImagePreview, setShowImagePreview] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [ratings, setRatings] = useState([]);
  let [ratingsLoading, setRatingsLoading] = useState(true);
  const [ratingsPagination, setRatingsPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    hasNextPage: false,
    hasPreviousPage: false,
  });

  const handleImagePreview = () => {
    setShowImagePreview(true);
  };

  const closeImagePreview = () => {
    setShowImagePreview(false);
  };

  const initialValues = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    address: "",
    vehicleId: "",
    rating: "",
    pocket: "",
    gender: "",
    driverScince: "",
    driverImage: "",
    documents: "",
    refresh_token: "",
    trips: [],
    creditHistory: [],
    balance: "",
    vehicle: [],
  };
  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const getDriver = async () => {
    try {
      const response = await axios.get("/driver/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      });

      const driverData = response.data.driver;

      setFirstName(driverData.firstName);
      setLastName(driverData.lastName);
      setPhoneNumber(driverData.phoneNumber);
      setGender(driverData.gender);
      setAddress(driverData.address);
      setRating(driverData.rating);
      setBalance(driverData.balance);
      setPocket(driverData.pocket);
      setDriverSince(driverData.driverScince);
      setMeansOfTransport(driverData.meansOfTransport);
      // setDocuments(driverData.attachments);

      // Fetch the image with headers
      driverData.attachments.forEach((attachment) => {
        console.log(attachment, "attachment");
        
        if (attachment.attachmentType === ATTACHMENT_TYPES.DRIVER_IMAGE) {
          fetchDriverImage(attachment.filePath, setDriverImage);
        }

        if (attachment.attachmentType === ATTACHMENT_TYPES.DRIVER_LICENSE) { 
          fetchDocument(attachment.filePath, setDocuments);
        }
      })
      // fetchDocument(driverData.documents, setDocuments);
      // fetchDriverImage(driverData.driverImage, setDriverImage);
      setLoading(false);
    } catch (err) {
      notifyError();
      setLoading(false);
    }
  };

  // const getDriver = async () => {
  //   axios
  //     .get("/driver/" + id)
  //     .then((res) => {
  //       setFirstName(res.data.driver.firstName);
  //       setLastName(res.data.driver.lastName);
  //       setPhoneNumber(res.data.driver.phoneNumber);
  //       setGender(res.data.driver.gender);
  //       setAddress(res.data.driver.address);
  //       setRating(res.data.driver.rating);
  //       setBalance(res.data.driver.balance);
  //       setDriverImage(res.data.driver.driverImage);
  //       setDriverSince(res.data.driver.driverScince);
  //       setDocuments(res.data.driver.documents);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       notifyError();
  //     });
  // };

  const getTrips = async () => {
    const response = await axios
      .get("/driverTrips/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
        },
      })
      .then((ress) => {
        const newData = ress.data.map((res) => {
          return {
            ...res,
            passenger: {
              ...res.passenger,
              name: res.passenger.firstName + " " + res.passenger.lastName,
            },
          };
        });

        setTrips(newData);
        setTripsLoading(false);
      })
      .catch((err) => {
        setTripsLoading(false);
        notifyError();
      });
  };
  const getDrivers = async () => {
    try {
      const response = await axios
        .get("/drivers/byPromoCode/" + id)
        .then((res) => {
          setDrivers(res.data);
          setDriversLoading(false);
          // notify()
        })
        .catch((err) => {
          setDriversLoading(false);
          notifyError();
        });
    } catch (error) {
      setDriversLoading(false);
      notifyError();
    }
  };

  const getEarnings = async () => {
    const response = await axios
      .get("/drivers/earnings/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
        },
      })
      .then((res) => {
        setEarnings(res.data);
        setReportsLoading(false);
      })
      .catch((err) => {
        setReportsLoading(false);
        notifyError();
      });
  };

  const getRatings = async (page = 1, limit = 5) => {
    try {
      setRatingsLoading(true);
      const response = await axios.get(`/driver/${id}/ratings`, {
        params: { page, limit },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
        },
      });
      setRatings(response.data.ratings);
      setRatingsPagination(response.data.pagination);
      setRatingsLoading(false);
    } catch (err) {
      console.error("Error fetching ratings:", err);
      setRatingsLoading(false);
      notifyError();
    }
  };

  // const getVehicles = async () => {
  //   const response = await axios
  //     .get("/driversVehicle/" + id)
  //     .then((res) => {
  //       setVehicle(res.data);
  //       setVehiclesLoading(false);
  //     })
  //     .catch((err) => {
  //       notifyError();
  //     });
  // };

  const getVehicles = async () => {
    try {
      const response = await axios.get("/driversVehicle/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      });

      setVehicle(response.data);
      setVehiclesLoading(false);

      // Fetch images for each vehicle with headers
      fetchVehicleImages(response.data.vehicleImage, setVehicleImage);
    } catch (err) {
      notifyError();
    }
  };

  useEffect(() => {
    getTrips();
    getVehicles();
    getDriver();
    getDrivers();
    getEarnings();
    getRatings();
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        columns: [
          {
            Header: "ID",
            accessor: "id",
          },
          {
            Header: "First Name",
            accessor: "firstName",
          },
          {
            Header: "Last Name",
            accessor: "lastName",
          },
          {
            Header: "Gender",
            accessor: "gender",
          },
        ],
      },
      {
        Header: "Info",
        columns: [
          {
            Header: "Phone",
            accessor: "phoneNumber",
          },
          {
            Header: "Address",
            accessor: "address",
          },
          {
            Header: "Rating",
            accessor: "rating",
          },
          {
            Header: "Balance",
            accessor: "balance",
          },
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                {(() => {
                  if (row.cell.row.original.status == "Active") {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="success"
                      >
                        {" "}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="warning"
                      >
                        {" "}
                      </Badge>
                    );
                  }
                })()}
              </div>
            ),
          },
          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div></div>
             
            ),
          },
        ],
      },
    ],
    []
  );

  const columns_expo = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "createdAt",
      },
      {
        Header: "Driver",
        accessor: "passenger.name",
      },
      {
        Header: "From",
        accessor: "pickUpPlace",
      },
      {
        Header: "To",
        accessor: "destinationPlace",
      },

      {
        Header: "Amount Paid",
        accessor: "actualPrice",
      },
      {
        Header: "Status",
        accessor: "status",
      },
    ],
    []
  );

  var isVehicle = false;

  if (vehicle !== null && vehicle !== undefined) {
    isVehicle = true;
  }

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportTripDetail(
      trips,
      columns_expo,
      "driver",
      "driver_details.pdf",
      selectedColumns,
      firstName + " " + lastName
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }

  const reportStyles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "100vh",
      marginTop: "50px",
    },
    button: {
      // backgroundColor: "green",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      display: "flex",
      justifyContent: "space-around",
    },
    buttonTwo: {
      border: "none",
      transition: "background-color 0.3s",
      display: "flex",
      justifyContent: "space-around",
      fontSize: "20px",
    },
    contain: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#198754",
      // margin: "10px",
      // padding: "20px 20px",
      // width: "270px",
      fontSize: "22px",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    },
    icon: {
      fontWeight: "bold",
      fontSize: "20px",
      color: "white",
      marginLeft: "7px",
      marginRight: "3px",
    },
  };

  const prRef = useRef(null);
  const [isPrintableComponentVisible, setIsPrintableComponentVisible] =
    useState(false);

  const handlePrintButtonClick = () => {
    setIsPrintableComponentVisible(true);
  };

  const [formats, setFormats] = useState("PDF");
  const items = [
    {
      label: <p style={reportStyles.buttonTwo}>In EXCEL format</p>,
      key: "EXCEL",
    },
  ];
  const handleDropdownChange = (selectedFormat) => {
    if (selectedFormat === "EXCEL") {
      exportExcelDriverTrips(firstName + "_" + lastName, trips);
    } else {
      setFormats("PDF");
    }
  };

  const getTransportTypeText = (transportType) => {
    if (!transportType) return "Not specified";
    const transportEntry = Object.entries(MEANS_OF_TRANSPORT_TYPES).find(
      ([key, value]) => value === transportType
    );
    return transportEntry ? transportEntry[0].replace(/_/g, " ") : "Unknown";
  };

  const handleRatingsPageChange = (newPage) => {
    getRatings(newPage, 5);
  };

  const handleRatingsNextPage = () => {
    if (ratingsPagination.hasNextPage) {
      handleRatingsPageChange(ratingsPagination.currentPage + 1);
    }
  };

  const handleRatingsPreviousPage = () => {
    if (ratingsPagination.hasPreviousPage) {
      handleRatingsPageChange(ratingsPagination.currentPage - 1);
    }
  };

  return (
    <div className="content-wrappers">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Driver Detail</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/drivers">Home</a>
                </li>
                <li className="breadcrumb-item active">Driver Detail  </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <div
                className="card card-primary card-outline"
                style={{
                  boxShadow: " rgba(0, 0, 0, 0.09) 0px 3px 12px 0px",
                  borderRadius: "10px",
                  height: "100%",
                }}
              >
                <div className="card-body box-profile">
                  <div className="text-center">
                    {driverImage !== null && driverImage !== undefined ? (
                      <img
                        className="vmain"
                        src={driverImage}
                        style={{
                          maxHeight: "300px",
                          maxWidth: "300px",
                          width: "100%",
                          objectFit: "contain", // Adjust this property to fit your design needs
                        }}
                        alt="driver picture"
                      />
                    ) : (
                      <PermIdentity style={{ color: "green", fontSize: 350 }} />
                    )}
                  </div>

                  <h3 className="profile-username text-center">
                    {firstName} {lastName}{" "}
                  </h3>

                  <p className="text-muted text-center">
                    {phoneNumber} / {gender}{" "}
                  </p>
                  <p className="text-muted text-center">
                    Driver Scince {driverScince}{" "}
                  </p>

                  <ul className="list-group list-group-unbordered mb-3">
                    <li className="list-group-item">
                      {!reportsLoading && (
                        <div>
                          <b>Trips</b>{" "}
                          <span className="float-right">
                            {earnings.totalTrips}
                          </span>
                        </div>
                      )}
                    </li>
                    <li className="list-group-item">
                      <b>Rating</b> <a className="float-right">{rating}</a>
                    </li>
                    <li className="list-group-item">
                      <b>Current Balance</b>{" "}
                      <a className="float-right">
                        {parseFloat(balance).toFixed(2)}ETB
                      </a>
                    </li>
                    <li className="list-group-item">
                      <b>Pocket</b>{" "}
                      <a className="float-right">
                        {parseFloat(pocket).toFixed(2)}ETB
                      </a>
                    </li>
                    <li className="list-group-item">
                      <b>Means of Transport</b>{" "}
                      <a className="float-right">
                        {getTransportTypeText(meansOfTransport)}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-9">
              <div className="row">
                <div
                  className="col-md-6 card card-primary card-outline"
                  style={{
                    boxShadow: " rgba(0, 0, 0, 0.09) 0px 3px 12px 0px",
                    borderRadius: "10px",
                    backgroundColor: "white",
                    maxWidth: "400px",
                  }}
                >
                  <div className="card-header p-2">
                    <span
                      className=""
                      style={{
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                    >
                      Drivers Licence
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "black",
                    }}
                  >
                    {documents !== null && documents !== undefined ? (
                      <img
                        src={documents}
                        // className="vimg"
                        alt="Image Preview"
                        onClick={handleImagePreview}
                        style={{
                          maxHeight: "300px",
                          maxWidth: "300px",
                          width: "100%",
                          objectFit: "contain", // Adjust this property to fit your design needs
                        }}
                      />
                    ) : (
                      <Attachment style={{ color: "#7a7676", fontSize: 200 }} />
                    )}
                   
                  </div>

                </div>

                {vehiclesLoading && (
                  <div>
                    <Spinner />
                  </div>
                )}
                {/* {!vehiclesLoading && (
                  <div className="col-md-6">
                    {isVehicle && (
                      <div
                        className="card card-primary card-outline"
                        style={{
                          boxShadow: " rgba(0, 0, 0, 0.09) 0px 3px 12px 0px",
                          borderRadius: "10px",
                          backgroundColor: "white",
                        }}
                      >
                        <div className="card-body box-profile">
                          <div className="card-header p-2">
                            <span
                              className=""
                              style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                              }}
                            >
                              Vehicle Info
                            </span>
                          </div>
                          <div
                            className="row"
                            style={{
                              display: "flex",
                            }}
                          >
                            <div className="col-md-4">
                              <div className="text-center">
                                {vehicleImage !== null &&
                                  vehicleImage !== undefined ? (
                                  <img
                                    className="vimg"
                                    src={vehicleImage}
                                    style={{
                                      maxHeight: "300px",
                                      maxWidth: "300px",
                                      width: "100%",
                                      //  objectFit: "contain", // Adjust this property to fit your design needs
                                    }}
                                    alt="driver picture"
                                  />
                                ) : (
                                  <DirectionsCar
                                    style={{ color: "#7a7676", fontSize: 200 }}
                                  />
                                )}
                               
                              </div>
                            </div>

                            <div className="col-md-6 ml-6">
                              <ul className="list-group list-group-unbordered mb-3">
                                <li className="list-group-item">
                                  <b>Plate Number</b>{" "}
                                  <a className="float-right">
                                    {vehicle.plateNumber}
                                  </a>
                                </li>
                                <li className="list-group-item">
                                  <b>Model</b>{" "}
                                  <a className="float-right">{vehicle.model}</a>
                                </li>
                                <li className="list-group-item">
                                  <b>Color</b>{" "}
                                  <a className="float-right">{vehicle.color}</a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) 
                   
                    }
                  </div>
                )} */}
              </div>

              <Tabs value={currentTab} onChange={handleTabChange}>
                <Tab label="Trips History" />
                <Tab label="Earnings" />
                <Tab label="Drivers by Promo Code" />
                <Tab label="Corporate Transactions" />
                <Tab label="Withdrawals from Pocket" />
                <Tab label="Ratings & Reviews" />
              </Tabs>
              <TabPanel value={currentTab} index={0}>
                {tripsLoading ? (
                  <Spinner />
                ) : (
                  <div className="card card-primary card-outline">
                    <div className="card-header p-2">
                      <span
                        className=""
                        style={{
                          fontWeight: "bold",
                          fontSize: "15px",
                        }}
                      >
                        Trips History
                      </span>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          marginLeft: "auto",
                          gap: "10px",
                        }}
                      >
                        <Button
                          onClick={showModal}
                          className="btn btn-success bt"
                        >
                          Export
                        </Button>
                        <div style={reportStyles.contain}>
                          <ReactToPrint
                            trigger={() => (
                              <Button
                                onClick={handlePrintButtonClick}
                                className="btn btn-success bt p-3"
                              >
                                Print(PDF)
                              </Button>
                            )}
                            content={() => prRef.current}
                          />
                          <Dropdown
                            overlay={
                              <Menu>
                                {items.map((item) => (
                                  <Menu.Item
                                    key={item.key}
                                    onClick={() =>
                                      handleDropdownChange(item.key)
                                    }
                                  >
                                    {item.label}
                                  </Menu.Item>
                                ))}
                              </Menu>
                            }
                            trigger={["click"]}
                          >
                            <a onClick={(e) => e.preventDefault()}>
                              <Space>
                                <DownOutlined style={reportStyles.icon} />
                              </Space>
                            </a>
                          </Dropdown>
                          <div
                            style={{
                              display: isPrintableComponentVisible
                                ? "block"
                                : "none",
                            }}
                          >
                            <DriverTrips
                              name={firstName + " " + lastName}
                              trips={trips}
                              prRef={prRef}
                            />
                          </div>
                        </div>
                      </div>

                      <Modal
                      style={{marginTop: "60px"}}
                        title="Select Columns to Export"
                        visible={isModalVisible}
                        onOk={handleOkModal}
                        onCancel={handleCancel}
                        footer={[
                          <Button key="cancel" onClick={handleCancel}>
                            Cancel
                          </Button>,
                          <Button
                            style={{ marginLeft: "10px" }}
                            key="ok"
                            type="primary"
                            onClick={handleOkModal}
                          >
                            OK
                          </Button>,
                        ]}
                      >
                        <div style={{ marginBottom: "20px" }}>
                          {columns_expo.map((column) => (
                            <div
                              key={column.Header}
                              style={{ marginBottom: "10px" }}
                            >
                              <Checkbox
                                checked={selectedColumns.includes(
                                  column.Header
                                )}
                                onChange={() =>
                                  handleColumnToggle(column.Header)
                                }
                                style={{
                                  marginRight: "10px",
                                  fontSize: "16px",
                                }}
                              >
                                {column.Header}
                              </Checkbox>
                            </div>
                          ))}
                        </div>
                      </Modal>
                    </div>

                    {tripsLoading && (
                      <div>
                        <Spinner />
                      </div>
                    )}
                    {!tripsLoading && (
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th width="10%">Date</th>
                            <th width="20%">Passenger</th>
                            <th width="20%">From</th>
                            <th width="20%">To</th>
                            <th width="10%">Amount Paid</th>
                            <th width="10%">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {trips.map((trip) => {
                            if (
                              trip.createdAt === undefined ||
                              trip.createdAt === null
                            ) {
                              return (
                                <ClipLoader
                                  color={"$ffffff"}
                                  loading={true}
                                  cssOverride={true}
                                  size={150}
                                  aria-label="Loading Spinner"
                                  data-testid="loader"
                                />
                              );
                            } else {
                              return (
                                <tr>
                                  <td>{trip.createdAt.substring(0, 10)}</td>
                                  <td>
                                    {trip.passenger !== undefined &&
                                      trip.passenger !== null &&
                                      trip.passenger.firstName +
                                      " " +
                                      trip.passenger.lastName}
                                  </td>

                                  <td> {trip.pickUpPlace}</td>
                                  <td> {trip.destinationPlace}</td>
                                  {trip.status == "Ended" && (
                                    <td> {trip.actualPrice}&nbsp;ETB</td>
                                  )}
                                  {trip.status == "Active" && (
                                    <td>
                                      {" "}
                                      {trip.estimatedPrice}&nbsp;ETB - Estimated{" "}
                                    </td>
                                  )}
                                  {trip.status == "Active" && (
                                    <td>
                                      <span class="badge bg-warning">
                                        Active
                                      </span>
                                    </td>
                                  )}
                                  {trip.status == "Ended" && (
                                    <td>
                                      <span class="badge bg-success">
                                        Completed
                                      </span>
                                    </td>
                                  )}
                                </tr>
                              );
                            }
                          })}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
              </TabPanel>
              <TabPanel value={currentTab} index={1}>
                {tripsLoading ? (
                  <Spinner />
                ) : (
                  <div className="card card-primary card-outline">
                    <div className="card-header p-2">
                      <span
                        className=""
                        style={{
                          fontWeight: "bold",
                          fontSize: "15px",
                        }}
                      >
                        Trips History
                      </span>
                    </div>

                    {reportsLoading && (
                      <div>
                        <Spinner />
                      </div>
                    )}
                    {!reportsLoading && (
                      <Card elevation={3}>
                        <CardContent>
                          <Typography variant="h6" gutterBottom>
                            Dashboard Report
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={3}>
                              <ReportInfo
                                title="Total Earnings"
                                value={earnings.totalEarnings}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                              <ReportInfo
                                title="Daily Earnings"
                                value={earnings.dailyEarnings}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                              <ReportInfo
                                title="Weekly Earnings"
                                value={earnings.weeklyEarnings}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                              <ReportInfo
                                title="Monthly Earnings"
                                value={earnings.monthlyEarnings}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                              <ReportInfo
                                title="Total Trips"
                                value={earnings.totalTrips}
                              />
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    )}
                  </div>
                )}
              </TabPanel>

              {/* Drivers by Promo Code Tab */}
              <TabPanel value={currentTab} index={2}>
                {driversLoading ? (
                  <Spinner />
                ) : (
                  <div className="card card-primary card-outline">
                    <div className="card-header p-2">
                      <span
                        className=""
                        style={{
                          fontWeight: "bold",
                          fontSize: "15px",
                        }}
                      >
                        Drivers Registered by Promocode
                      </span>
                    </div>

                    {driversLoading && (
                      <div>
                        <Spinner />
                      </div>
                    )}
                    {!driversLoading && (
                      <Table
                        columns={columns}
                        data={drivers}
                        edit={edit}
                        detail={detail}
                      />
                    )}
                  </div>
                )}
              </TabPanel>

              {/* Corporate Transactions Tab */}
              {driversLoading && (
                <div>
                  <Spinner />
                </div>
              )}
              {!driversLoading && (
                <TabPanel value={currentTab} index={3}>
                  <Transactions type="driver" />
                </TabPanel>
              )}
              <TabPanel value={currentTab} index={4}>
                <Withdrawals />
              </TabPanel>
              
              {/* Ratings & Reviews Tab */}
              <TabPanel value={currentTab} index={5}>
                {ratingsLoading ? (
                  <Spinner />
                ) : (
                  <div className="card card-primary card-outline">
                    <div className="card-header p-2">
                      <div className="d-flex justify-content-between align-items-center">
                        <span
                          className=""
                          style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                          }}
                        >
                          Driver Ratings & Reviews
                        </span>
                        {ratingsPagination.totalCount > 0 && (
                          <Typography variant="body2" color="text.secondary">
                            Total: {ratingsPagination.totalCount} reviews
                          </Typography>
                        )}
                      </div>
                    </div>
                    <div className="card-body">
                      {ratings.length === 0 ? (
                        <div className="text-center p-4">
                          <Typography variant="h6" color="textSecondary">
                            No ratings yet
                          </Typography>
                        </div>
                      ) : (
                        <div>
                          {ratings.map((rating, index) => (
                            <Card key={index} className="mb-3" elevation={2}>
                              <CardContent>
                                <div className="d-flex justify-content-between align-items-start">
                                  <div className="d-flex align-items-center">
                                    <Avatar sx={{ bgcolor: 'primary.main', mr: 2 }}>
                                      <Person />
                                    </Avatar>
                                    <div>
                                      <Typography variant="h6" component="div">
                                        {rating.passenger ? 
                                          `${rating.passenger.firstName} ${rating.passenger.lastName}` : 
                                          'Unknown Passenger'
                                        }
                                      </Typography>
                                      <Typography variant="body2" color="text.secondary">
                                        {rating.passenger?.phoneNumber || 'No phone number'}
                                      </Typography>
                                    </div>
                                  </div>
                                  <div className="text-right">
                                    <div className="d-flex align-items-center mb-1">
                                      {[...Array(5)].map((_, starIndex) => (
                                        <Star
                                          key={starIndex}
                                          style={{
                                            color: starIndex < parseInt(rating.rating) ? '#ffd700' : '#ddd',
                                            fontSize: '20px'
                                          }}
                                        />
                                      ))}
                                      <Typography variant="body1" className="ml-2">
                                        ({rating.rating}/5)
                                      </Typography>
                                    </div>
                                    <Typography variant="body2" color="text.secondary">
                                      {new Date(rating.createdAt).toLocaleDateString()}
                                    </Typography>
                                  </div>
                                </div>
                                {rating.feedback && (
                                  <div className="mt-3">
                                    <Typography variant="body1" style={{ fontStyle: 'italic' }}>
                                      "{rating.feedback}"
                                    </Typography>
                                  </div>
                                )}
                              </CardContent>
                            </Card>
                          ))}
                          
                          {/* Pagination Controls */}
                          {ratingsPagination.totalPages > 1 && (
                            <div className="d-flex justify-content-between align-items-center mt-4">
                              <div className="d-flex align-items-center">
                                <Typography variant="body2" color="text.secondary">
                                  Showing page {ratingsPagination.currentPage} of {ratingsPagination.totalPages}
                                </Typography>
                              </div>
                              <div className="d-flex gap-2">
                                <MuiButton
                                  variant="outlined"
                                  size="small"
                                  disabled={!ratingsPagination.hasPreviousPage}
                                  onClick={handleRatingsPreviousPage}
                                  startIcon={<ChevronRight style={{ transform: 'rotate(180deg)' }} />}
                                >
                                  Previous
                                </MuiButton>
                                <div className="d-flex align-items-center mx-3">
                                  {/* Page numbers */}
                                  {Array.from(
                                    { length: Math.min(5, ratingsPagination.totalPages) },
                                    (_, index) => {
                                      const startPage = Math.max(
                                        1,
                                        ratingsPagination.currentPage - 2
                                      );
                                      const pageNumber = startPage + index;
                                      if (pageNumber <= ratingsPagination.totalPages) {
                                        return (
                                          <MuiButton
                                            key={pageNumber}
                                            variant={pageNumber === ratingsPagination.currentPage ? "contained" : "text"}
                                            size="small"
                                            onClick={() => handleRatingsPageChange(pageNumber)}
                                            style={{ minWidth: '32px', margin: '0 2px' }}
                                          >
                                            {pageNumber}
                                          </MuiButton>
                                        );
                                      }
                                      return null;
                                    }
                                  )}
                                </div>
                                <MuiButton
                                  variant="outlined"
                                  size="small"
                                  disabled={!ratingsPagination.hasNextPage}
                                  onClick={handleRatingsNextPage}
                                  endIcon={<ChevronRight />}
                                >
                                  Next
                                </MuiButton>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </TabPanel>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
const ReportInfo = ({ title, value }) => {
  return (
    <div className="report-info">
      <Typography variant="body1">{title}</Typography>
      <Typography variant="h6" color="primary">
        {value.toFixed(2)}
      </Typography>
    </div>
  );
};

export default ViewDriver;
